module.exports = "<span>{{count}}</span>\r\n"